import { IAccountTransaction, IAccountTransactionDetail } from './AccountDomain'
import { AddressType } from './ProfileDomain'

export const MIN_EXPOSED_EXPIRATION_DAYS = 60

export const DEBIT_CARD_NO_LENGTH = 16
export const DEBIT_CARD_CVV_LENGTH = 3
export const DEBIT_CARD_EXPIRY_DATE_LENGTH = 5

export const MAX_CANCELLABLE_DAYS = 14
export const NOTE_MAX_LENGTH = 40

export const SCROLL_POSITION_Y_DEBIT_CARD_ACTIVATE = 64

export const HistoryListRequestRowCount = 20

export const IS_DOMESTIC_USE = 'isDomesticUse'
export const IS_OVERSEA_USE = 'isOverseaUse'
export const SINGLE_TRANSACTION_LIMIT_AMOUNT = 'singleTransactionLimitAmount'
export const DAILY_LIMIT_AMOUNT = 'dailyLimitAmount'

export const TRANSACTION_LIMIT = {
  UNIT: 5000000,
  SINGLE: {
    MIN: 0,
    MAX: 30000000,
  },
  DAILY: {
    MIN: 0,
    MAX: 50000000,
  },
}

export enum ReIssueReasonTypeCode {
  LOST = '00',
  DAMAGED = '01',
}

export enum DebitCardDesignTypeCode {
  BROWN_VISA = '71',
  SALLY_VISA = '72',
  CONY_VISA = '73',
  BROWN_DOMESTIC = '74',
  BT_PURPLE = '75',
  BT_SILVER = '76',
  EZL = '77',
}

export enum DebitCardVersion {
  VISA_CONTACTLESS = 'A',
  VISA = 'B',
  GPN = 'C',
  EZL_CARD = 'D',
}

export enum DebitCardBrand {
  A = 'VISA CONTACTLESS',
  B = 'VISA',
  C = 'GPN',
  D = '',
}

export interface IDebitCardType {
  debitCardDesignTypeCode: DebitCardDesignTypeCode
  debitCardVersion: DebitCardVersion
  debitCardBrand: DebitCardBrand
  designNameCode: string
  brandNameCode: string
  imageUrl: string
}

// ! 브라운VISA(1-b) > 코니VISA(1-c) > 샐리VISA(1-s) > 브라운GPN(2-b)
// 20211125 수정 yellow > pink > red > blue > purple
export const DEBIT_CARD_DESIGN_LIST: IDebitCardType[] = [
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.SALLY_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_3',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-sally-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.CONY_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_2',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-cony-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_1',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-brown-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_DOMESTIC,
    debitCardVersion: DebitCardVersion.GPN,
    debitCardBrand: DebitCardBrand.C,
    designNameCode: 'debitcard_carddesign_name_gpn_1',
    brandNameCode: 'debitcard_cardinfo_brand_domestic_desc',
    imageUrl: 'img/debitcard/debitcard-illust-2-brown-blue-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BT_PURPLE,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_5',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/BT21_Purple_1_2.png',
  },
]

export const DEBIT_CARD_DESIGN_LIST_V2: IDebitCardType[] = [
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.SALLY_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_3',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-sally-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.CONY_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_2',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-cony-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_VISA,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_1',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/debitcard-illust-1-brown-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_DOMESTIC,
    debitCardVersion: DebitCardVersion.GPN,
    debitCardBrand: DebitCardBrand.C,
    designNameCode: 'debitcard_carddesign_name_gpn_1',
    brandNameCode: 'debitcard_cardinfo_brand_domestic_desc',
    imageUrl: 'img/debitcard/debitcard-illust-2-brown-blue-vertical.png',
  },
  {
    debitCardDesignTypeCode: DebitCardDesignTypeCode.BT_PURPLE,
    debitCardVersion: DebitCardVersion.VISA_CONTACTLESS,
    debitCardBrand: DebitCardBrand.A,
    designNameCode: 'debitcard_carddesign_name_visa_5',
    brandNameCode: 'debitcard_cardinfo_brand_oversea_desc',
    imageUrl: 'img/debitcard/BT21_Purple_1_2.png',
  },
]

export const DEBIT_CARD_DESIGN_EZL: IDebitCardType = {
  debitCardDesignTypeCode: DebitCardDesignTypeCode.EZL,
  debitCardVersion: DebitCardVersion.EZL_CARD,
  debitCardBrand: DebitCardBrand.D,
  designNameCode: 'debitcard_carddesign_name_transport_1',
  brandNameCode: 'debitcard_cardinfo_brand_transport_desc',
  imageUrl: 'img/debitcard/transportcard-illust-vertical.png',
}

export enum ShippingStatusTypeCode {
  REQUESTED = '00',
  MAKING = '01',
  SHIPPING = '02',
  ACTIVATION = '09',
}

export enum DebitCardStatusTypeCode {
  CURRENT = '00',
  SHIPPING = '01',
  LOCKED = '03',
  LOST = '06',
  BLOCKED = '07',
  EXPIRED = '08',
  CLOSED = '09',
}

export interface IDebitCardEzlInquiryResponse extends IEzlShippingInfo {
  cardStatusTypeCode: DebitCardStatusTypeCode
  crdVersion: DebitCardVersion
  currentShippingStatusTypeCode: ShippingStatusTypeCode
  customerName: string
  debitCardDesignTypeCode: DebitCardDesignTypeCode
  expiredDate: string //DDMMYYYY
  medNo: string
  openDate: string //DDMMYYYY
  registrationDatetime: number // 신청일시 timestamp
}

export interface IDebitCardHistoryIdentity {
  refNo: string
}

export interface IDebitCardCancellationIdentity {
  refNo1: string
  refNo2?: string
  refNo3?: string
}

export interface IDebitCardDetailIdentity {
  refNo1: string
  refNo2: string
}

export interface IDebitCardTransactionDetailIdentity {
  refNo1: string
  refNo2: string
}

export interface IAdditionalInfo {
  autoClosingDate: number
  currentMonthStartDate: number
  customerName: string
  dailyLimitAmount: string
  debitCardNo: string
  expiredDate: number
  isDomesticUse: boolean
  isOverseaUse: boolean
  linkedAcctNo: string
  linkedAcctTitle: string
  reportedDate: number
  singleTransactionLimitAmount: string
  totalBenefitAmount: string
  totalTransactionAmount: string
}

interface IShippingInfo {
  currentShippingStatusTypeCode: ShippingStatusTypeCode
  isShippingDelayed: boolean
  shippingAddress: ISimpleAddress
  shippingHistoryList: IShippingHistory[]
  shippingVendorInfo: {
    deliveryBranchName: string
    deliveryEmployeeName: string
    deliveryVendorName: string
  }
}
type IEzlShippingInfo = Pick<
  IShippingInfo,
  'shippingAddress' | 'shippingHistoryList' | 'shippingVendorInfo'
>

export interface ISimpleAddress {
  address: string // 전체 주소
  cityCode: string // Kabupaten(DATI II) 코드
  mobileNo: string // 고객 전화번호
  provinceCode: string // Province 코드
  zipCode: number // 우편번호
}

interface IShippingHistory {
  startedDate: number
  shippingStatusTypeCode: ShippingStatusTypeCode
}

export interface IDebitCardInfo {
  additionalInfo?: IAdditionalInfo
  debitCardNo: string
  debitCardStatusTypeCode: DebitCardStatusTypeCode
  debitCardDesignTypeCode: DebitCardDesignTypeCode
  debitCardVersion: DebitCardVersion
  debitCardBrand: DebitCardBrand
  shippingInfo?: IShippingInfo
}

export interface IDebitCardWithAmount {
  acctNo: string
  acctTitle: string
  debitCardDesignTypeCode: DebitCardDesignTypeCode
  debitCardNo: string
  debitCardShippingStatusTypeCode: ShippingStatusTypeCode
  debitCardStatusTypeCode: DebitCardStatusTypeCode
  expiredDate: number
  totalAmount: string
}

export enum OrderingTypeCode {
  LATEST = '01',
  OLDEST = '02',
}

export enum DebitCardTransactionFilterTypeCode {
  ALL = '0',
  TRANSACTION = '1',
  CANCELED = '2',
}

export const EmptyDebitCardInfo: IDebitCardInfo = {
  additionalInfo: {
    autoClosingDate: 0,
    currentMonthStartDate: 0,
    customerName: '',
    dailyLimitAmount: '',
    debitCardNo: '',
    expiredDate: 0,
    isDomesticUse: true,
    isOverseaUse: true,
    linkedAcctNo: '',
    linkedAcctTitle: '',
    reportedDate: 0,
    singleTransactionLimitAmount: '',
    totalBenefitAmount: '',
    totalTransactionAmount: '',
  },
  debitCardNo: '',
  debitCardStatusTypeCode: DebitCardStatusTypeCode.CURRENT,
  debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_DOMESTIC,
  debitCardBrand: DebitCardBrand.C,
  debitCardVersion: DebitCardVersion.GPN,
  shippingInfo: {
    currentShippingStatusTypeCode: ShippingStatusTypeCode.REQUESTED,
    isShippingDelayed: false,
    shippingAddress: {
      address: '',
      cityCode: '',
      mobileNo: '',
      zipCode: 0,
      provinceCode: '',
    },
    shippingHistoryList: [
      {
        startedDate: 0,
        shippingStatusTypeCode: ShippingStatusTypeCode.REQUESTED,
      },
    ],
    shippingVendorInfo: {
      deliveryBranchName: '',
      deliveryEmployeeName: '',
      deliveryVendorName: '',
    },
  },
}

export const EmptyEzlCardInfo: IDebitCardInfo = {
  debitCardStatusTypeCode: DebitCardStatusTypeCode.CURRENT,
  debitCardVersion: DebitCardVersion.VISA,
  debitCardBrand: DebitCardBrand.D,
  debitCardDesignTypeCode: DebitCardDesignTypeCode.EZL,
  debitCardNo: '',
  shippingInfo: {
    shippingAddress: {
      address: '',
      cityCode: '',
      mobileNo: '',
      zipCode: 0,
      provinceCode: '',
    },
    shippingHistoryList: [
      {
        startedDate: 0,
        shippingStatusTypeCode: ShippingStatusTypeCode.REQUESTED,
      },
    ],
    shippingVendorInfo: {
      deliveryBranchName: '',
      deliveryEmployeeName: '',
      deliveryVendorName: '',
    },
    currentShippingStatusTypeCode: ShippingStatusTypeCode.REQUESTED,
    isShippingDelayed: false,
  },
}

export const EmptyDebitCardInfoWithAmount: IDebitCardWithAmount = {
  acctNo: '9010300001001231771',
  acctTitle: 'my main account',
  debitCardDesignTypeCode: DebitCardDesignTypeCode.BROWN_DOMESTIC,
  debitCardNo: '11112222333344444',
  debitCardShippingStatusTypeCode: ShippingStatusTypeCode.REQUESTED,
  debitCardStatusTypeCode: DebitCardStatusTypeCode.CURRENT,
  expiredDate: 1738335599000,
  totalAmount: '433627',
}

export enum DebitCardTransactionType {
  ATM_DEPOSIT = '4202', // ATM 입금 (only 당행)
  ATM_DEPOSIT_CANCEL = '4203', // ATM 입금 취소
  ATM_WITHDRAWAL_INTRA = '4102', // ATM 출금 (당행)
  ATM_WITHDRAWAL_INTER = '4101', // ATM 출금 (타행)
  ATM_WITHDRAWAL_CANCEL = '4103', // ATM 출금 취소
  ATM_TRANSFER_INTRA = '5122', // ATM 이체 (당행)
  ATM_TRANSFER_INTER = '5121', // ATM 이체 (타행)
  ATM_TRANSFER_CANCEL = '5123', // ATM 이체 실패
  PAYMENT = '7111', // 오프라인 카드 결제
  PAYMENT_ONLINE = '5111', // 온라인 카드 결제
  PAYMENT_ONLINE_REFUND = '5212', //온라인 카드 결제 환불
  PAYMENT_CASHBACK = '7241', // 카드 결제 캐시백
  PAYMENT_CANCELED = '7212', // 카드 결제 취소
  ISSUE_FEE = '7131', // 카드 발급 수수료
  RETURN_ISSUE_FEE = '7232', // 카드 발급 수수료 환불
}

export enum ForeignCurrencyType {
  USD = '00',
}

export interface IDebitCardTransaction {
  amount: string // 거래금액
  amountByForeignCurrency: string // 거래금액(외화)
  cashBackAmount: string // 혜택금액(캐쉬백)
  debitCardTransactionTypeCode: DebitCardTransactionType // 거래종류
  feeFreeAmount: string // 혜택금액(수수료 무료)
  foreignExchangeTypeCode: ForeignCurrencyType // 외화종류
  hisNo: string // 거래참조번호
  merchantName: string // 사용처
  note: string // 노트
  refNo: string // 거래 참조 번호
  transactionDate: number // 거래시각
}

export const EmptyDebitCardTransaction: IDebitCardTransaction = {
  amount: '5000.00',
  amountByForeignCurrency: '',
  cashBackAmount: '0',
  debitCardTransactionTypeCode: DebitCardTransactionType.ATM_DEPOSIT,
  feeFreeAmount: '0',
  foreignExchangeTypeCode: ForeignCurrencyType.USD,
  hisNo: '15126236508',
  merchantName: '',
  note: 'lucky money',
  refNo: '998022000039912',
  transactionDate: 1570375851000,
}

export const EmptyShippingAddress = {
  provinceCode: '',
  provinceName: '',
  cityCode: '',
  cityName: '',
  districtCode: '',
  districtName: '',
  subDistrictCode: '',
  subDistrictName: '',
  zipCode: '',
  detailAddress: '',
  isDisabledShipping: false,
}

export const FILTER_TYPE_BY_TRANSACTION = {
  [DebitCardTransactionType.ATM_DEPOSIT]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.ATM_DEPOSIT_CANCEL]: DebitCardTransactionFilterTypeCode.CANCELED,
  [DebitCardTransactionType.ATM_WITHDRAWAL_INTER]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.ATM_WITHDRAWAL_INTRA]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.ATM_WITHDRAWAL_CANCEL]: DebitCardTransactionFilterTypeCode.CANCELED,
  [DebitCardTransactionType.ATM_TRANSFER_INTER]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.ATM_TRANSFER_INTRA]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.ATM_TRANSFER_CANCEL]: DebitCardTransactionFilterTypeCode.CANCELED,
  [DebitCardTransactionType.PAYMENT]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.PAYMENT_ONLINE]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.PAYMENT_ONLINE_REFUND]: DebitCardTransactionFilterTypeCode.CANCELED,
  [DebitCardTransactionType.PAYMENT_CASHBACK]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.PAYMENT_CANCELED]: DebitCardTransactionFilterTypeCode.CANCELED,
  [DebitCardTransactionType.ISSUE_FEE]: DebitCardTransactionFilterTypeCode.TRANSACTION,
  [DebitCardTransactionType.RETURN_ISSUE_FEE]: DebitCardTransactionFilterTypeCode.CANCELED,
}

export type IDebitCardTransactionDetail = Pick<
  IAccountTransaction,
  'tranTrAmt' | 'tranAfJan' | 'tranTrCd' | 'hisNo' | 'trxNote' | 'tranTrDtm' | 'tselSerialNum'
> &
  Pick<
    IAccountTransactionDetail,
    | 'acctNo'
    | 'acctTitle'
    | 'trxOriAmt'
    | 'bfInt'
    | 'bnftFee'
    | 'trxOriCcy'
    | 'trxMerchantNm'
    | 'trxApprDtm'
    | 'trxAcctNm'
    | 'trxBnkNm'
    | 'trxAcctNo'
    | 'tselSerialNum'
  >

export const XLT_BY_ADDRESS_TYPE = {
  [AddressType.HOME]: 'debitcard_shipaddress_home_desc',
  [AddressType.WORK]: 'debitcard_shipaddress_company_desc',
  [AddressType.ETC]: 'debitcard_shipaddress_etc_desc',
}

export enum EzlCardStatus {
  CURRENT = '0',
  NOT_READY = '1',
  // INVALID_PIN = 3 ,
  // BLOCK = 7,
  // EXPIRED = 8,
  // CLOSED = 9
}

export interface IEzlCardDetail {
  debitCardNo: string
  debitCardStatus: EzlCardStatus
}
export interface IDebitCardEzlAvailableIssueResponse {
  issueAvailable: boolean
  issueCount: number
  list: IEzlCardDetail[]
  npwpSubmitted: boolean
}
